import { Component, ViewChild } from '@angular/core';

@Component({
    selector: 'become-dealer-terms-modal',
    template: require('./become-dealer-terms.component.html'),
    styles: [`
        .modal-content {
            max-width: 900px;
            width: 900px;
        }
    `]
})

export class BecomeDealerTermsModal {

    @ViewChild('modalBecomeDealerTerms', { static: false }) modalBecomeDealerTerms: any;

    onKeyUp(value: any) {
        this.modalBecomeDealerTerms.close();
    }

    closeModal(): void {
        this.modalBecomeDealerTerms.close();
    }

    beforeDismiss(): boolean {
        return true;
    }

    beforeClose(): boolean {
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/app/become-dealer/components/become-dealer-terms.component.ts